import { QUESTIONNAIRE_EVALUATION as MODULE_PREFIX } from '../constants';
export const QUESTIONNAIRE_EVALUATION_QUESTION_GET_REQUEST = `${MODULE_PREFIX}_QUESTION_GET_REQUEST`;
export const QUESTIONNAIRE_EVALUATION_QUESTION_GET_SUCCESS = `${MODULE_PREFIX}_QUESTION_GET_SUCCESS`;
export const questionnaireEvaluationQuestionGetAction = (requestData) => ({
    type: QUESTIONNAIRE_EVALUATION_QUESTION_GET_REQUEST,
    payload: requestData
});
export const questionnaireEvaluationQuestionGetSuccessAction = (questionData) => ({
    type: QUESTIONNAIRE_EVALUATION_QUESTION_GET_SUCCESS,
    payload: questionData
});
//# sourceMappingURL=questionnaireEvaluationQuestionGetActions.js.map